import { cn, twc } from "../utils";
import { AccentCheck } from "./accent-check";

export const PlanTraceCardRoot = twc.div`flex items-center gap-1.5 text-sm pt-2 animate-fade-in`;

export const PlanTraceSeparator = twc.span`font-normal text-text-secondary/35`;

export const PlanTraceCategory = twc.span`font-normal text-text-secondary/50 min-w-0 truncate`;

type PlanTraceCardProps = {
  category?: string;
  persisted?: boolean;
};

export function PlanTraceCard({ category, persisted }: PlanTraceCardProps) {
  return (
    <PlanTraceCardRoot
      className={cn(persisted ? "opacity-50" : "opacity-70 transition-opacity duration-300")}
      aria-live="polite"
    >
      <AccentCheck />
      <span className="font-medium text-accent">Added</span>
      {category && (
        <>
          <PlanTraceSeparator aria-hidden="true"> — </PlanTraceSeparator>
          <PlanTraceCategory>{category}</PlanTraceCategory>
        </>
      )}
    </PlanTraceCardRoot>
  );
}
